
// 将base64转换为blob
import * as CryptoJS from 'crypto-js';


export function convertBase64UrlToBlob(urlData) {
    let arr = urlData.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
}

// 压缩图片
export function compressImage(path) {
    //最大高度
    const maxHeight = 500;
    //最大宽度
    const maxWidth = 500;
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = path;
        img.onload = function () {
            const originHeight = img.height;
            const originWidth = img.width;
            let compressedWidth = img.height;
            let compressedHeight = img.width;
            if ((originWidth > maxWidth) && (originHeight > maxHeight)) {
                // 更宽更高，
                if ((originHeight / originWidth) > (maxHeight / maxWidth)) {
                    // 更加严重的高窄型，确定最大高，压缩宽度
                    compressedHeight = maxHeight
                    compressedWidth = maxHeight * (originWidth / originHeight)
                } else {
                    //更加严重的矮宽型, 确定最大宽，压缩高度
                    compressedWidth = maxWidth
                    compressedHeight = maxWidth * (originHeight / originWidth)
                }
            } else if (originWidth > maxWidth && originHeight <= maxHeight) {
                // 更宽，但比较矮，以maxWidth作为基准
                compressedWidth = maxWidth
                compressedHeight = maxWidth * (originHeight / originWidth)
            } else if (originWidth <= maxWidth && originHeight > maxHeight) {
                // 比较窄，但很高，取maxHight为基准
                compressedHeight = maxHeight
                compressedWidth = maxHeight * (originWidth / originHeight)
            } else {
                // 符合宽高限制，不做压缩
            }
            // 生成canvas
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            canvas.height = compressedHeight;
            canvas.width = compressedWidth;
            context.clearRect(0, 0, compressedWidth, compressedHeight);
            context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
            let base64 = canvas.toDataURL('image/*', 0.8);
            let blob = convertBase64UrlToBlob(base64);
            // 回调函数返回blob的值。也可根据自己的需求返回base64的值
            resolve(blob)
        }
    })
}

//随机字符串生成
export function randomLenNum(len, date) {
    let random = ''
    random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
    if (date) random = random + Date.now()
    return random
}

/**
 *加密处理
 */
 export function encryption(params) {
    let {
        data,
        type,
        param,
        key
    } = params
    const result = JSON.parse(JSON.stringify(data))
    if (type === 'Base64') {
        param.forEach(ele => {
            result[ele] = btoa(result[ele])
        })
    } else {
        param.forEach(ele => {
            var data = result[ele]
            key = CryptoJS.enc.Latin1.parse(key)
            var iv = key
            // 加密
            var encrypted = CryptoJS.AES.encrypt(
                data,
                key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding
            })
            result[ele] = encrypted.toString()
        })
    }
    return result
}